export default __webpack_public_path__ + "static/media/logo-vertical.075ab6c6.svg";